import React from 'react';

const Footer = () => {
    return (
        <div className="mt-5">
            <p className="text-center mt-5"><small>All rights reserved @2022</small></p>
        </div>
    );
};

export default Footer;